'use strict';

var styled = require('styled-components');

/**
 * Mixin to create a Safari-compatible outline pseudo-element.
 *   Because Safari's support for the "outline" property isn't
 *   great yet, we have to use other means.
 *
 * The reason to use a pseudo-element instead of a box shadow
 *   is that box-shadows do not support inner offsetting that
 *   well.
 *
 * Note that this mixin will set the affected element's `position`
 *   property to `relative`.
 *
 * @param {@see ElementOutlineMixinProps}
 * @returns CSS to be injected into another styled component
 */
var createElementOutlineMixin = function createElementOutlineMixin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '' : _ref$color,
    _ref$inset = _ref.inset,
    inset = _ref$inset === void 0 ? '0' : _ref$inset,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '1px' : _ref$width,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'solid' : _ref$style,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? '0' : _ref$radius;
  return styled.css(["outline:none;position:relative;&::after{content:'';display:block;position:absolute;top:", ";bottom:", ";left:", ";right:", ";border-radius:", ";border:", " ", " ", ";pointer-events:none;}"], inset, inset, inset, inset, radius, width, style, color);
};

exports.createElementOutlineMixin = createElementOutlineMixin;
//# sourceMappingURL=element-outline-e92b8ea2.js.map
